<template>
  <div class="spec" :class="{ closed: closed }">
    <a href="#" class="spec-handle" @click.prevent="toggle">
      <svg class="mb-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M8,16a7.7,7.7,0,0,0,5.65-2.35A7.7,7.7,0,0,0,16,8a7.7,7.7,0,0,0-2.35-5.65A7.7,7.7,0,0,0,8,0,7.7,7.7,0,0,0,2.35,2.35,7.7,7.7,0,0,0,0,8a7.7,7.7,0,0,0,2.35,5.65A7.7,7.7,0,0,0,8,16Z" style="fill:#346702"/><path d="M2.5,8.1l5,4.9,3,.1-4.05-4H13.5v-2h-7l3.9-4L7.45,3Z" style="fill:#fff"/></svg>
      建物仕様設定
    </a>
    <div class="spec-wrap">
      <div class="spec-window">
        <div class="spec-heading">建物仕様<small>ご希望の建物仕様を選択すると、概算算出費用に反映されます。</small></div>
        <div class="spec-formats">
          <div class="spec-formats-item" v-for="i in [0,1,2,3,4,5,6]">
            <div class="custom-control custom-radio custom-control-inline">
              <input class="custom-control-input" :id="`specformat${spec_formats[i].value}`" type="radio" :value="spec_formats[i].value" v-model="spec_format">
              <label class="custom-control-label" :for="`specformat${spec_formats[i].value}`">{{ spec_formats[i].label }}</label>
            </div>
          </div>
          <div class="spec-formats-item text-right">
            <a class="btn btn-primary btn-sm" :href="tatemono_shiyo_kaisetsu_url" target="_blank">
              建物仕様の解説
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10.1" style="vertical-align: baseline;">
                <path fill="currentColor" d="M3.1 0l4.1 4H0v2h7l-3.9 4 3 .1L11 5 6.1.1l-3-.1z"/>
              </svg>
            </a>
          </div>
        </div>
        <div class="spec-parameter">
          <div class="custom-control custom-radio custom-control-inline">
            <input class="custom-control-input" id="specformat7" type="radio" :value="7" v-model="spec_format">
            <label class="custom-control-label" for="specformat7">{{ spec_formats.find(sf => sf.value == 7).label }}</label>
            <small class="ml-2 align-self-center">※それぞれの仕様を細かく選択することができます。</small>
          </div>
          <div class="spec-table">
            <table class="table">
              <tbody>
                <tr>
                  <th><span>構造仕様</span></th>
                  <td>
                    <div class="row">
                      <div class="col-4">
                        <label for="PillarMaterial">柱材質：</label>
                        <a class="hatena" :href="spec1_1help_url" target="_blank">？</a>
                        <select id="PillarMaterial" class="custom-select custom-select-sm" v-model="pillar_material"><option v-for="option in options.pillar_material" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="RoofStructure">屋根構造：</label>
                        <a class="hatena" :href="spec1_2help_url" target="_blank">？</a>
                        <select id="RoofStructure" class="custom-select custom-select-sm" v-model="roof_structure"><option v-for="option in options.roof_structure" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="InsulationMaterial">断熱材質：</label>
                        <a class="hatena" :href="spec1_3help_url" target="_blank">？</a>
                        <select id="InsulationMaterial" class="custom-select custom-select-sm" v-model="insulation_material"><option v-for="option in options.insulation_material" :value="option.value">{{ option.label }}</option></select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>外観仕様</span></th>
                  <td>
                    <div class="row">
                      <div class="col-4">
                        <label for="ExteriorWallMaterial">外壁材質：</label>
                        <a class="hatena" :href="spec2_1help_url" target="_blank">？</a>
                        <select id="ExteriorWallMaterial" class="custom-select custom-select-sm" v-model="exterior_wall_material"><option v-for="option in options.exterior_wall_material" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="ExteriorRoofMaterial">屋根材質：</label>
                        <a class="hatena" :href="spec2_2help_url" target="_blank">？</a>
                        <select id="ExteriorRoofMaterial" class="custom-select custom-select-sm" v-model="exterior_roof_material"><option v-for="option in options.exterior_roof_material" :value="option.value">{{ option.label }}</option></select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>内装仕様</span></th>
                  <td>
                    <div class="row">
                      <div class="col-4">
                        <label for="InteriorRoofFinish">天井仕上げ：</label>
                        <a class="hatena" :href="spec3_1help_url" target="_blank">？</a>
                        <select id="InteriorRoofFinish" class="custom-select custom-select-sm" v-model="interior_roof_finish"><option v-for="option in options.interior_roof_finish" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="InteriorWallFinish">内装仕上げ：</label>
                        <a class="hatena" :href="spec3_2help_url" target="_blank">？</a>
                        <select id="InteriorWallFinish" class="custom-select custom-select-sm" v-model="interior_wall_finish"><option v-for="option in options.interior_wall_finish" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="InteriorFloorFinish">床面仕上げ：</label>
                        <a class="hatena" :href="spec3_3help_url" target="_blank">？</a>
                        <select id="InteriorFloorFinish" class="custom-select custom-select-sm" v-model="interior_floor_finish"><option v-for="option in options.interior_floor_finish" :value="option.value">{{ option.label }}</option></select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>設備仕様</span></th>
                  <td>
                    <div class="row">
                      <div class="col-4">
                        <label for="AntiPollenFacility">抗花粉設備：</label>
                        <a class="hatena" :href="spec4_1help_url" target="_blank">？</a>
                        <select id="AntiPollenFacility" class="custom-select custom-select-sm" v-model="anti_pollen_facility"><option v-for="option in options.anti_pollen_facility" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="NaturalEnergyFacility">自然エネルギー：</label>
                        <a class="hatena" :href="spec4_2help_url" target="_blank">？</a>
                        <select id="NaturalEnergyFacility" class="custom-select custom-select-sm" v-model="natural_energy_facility"><option v-for="option in options.natural_energy_facility" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="FloorHeatingFacility">床暖房：</label>
                        <a class="hatena" :href="spec4_3help_url" target="_blank">？</a>
                        <select id="FloorHeatingFacility" class="custom-select custom-select-sm" v-model="floor_heating_facility"><option v-for="option in options.floor_heating_facility" :value="option.value">{{ option.label }}</option></select>
                      </div>
                      <div class="col-4">
                        <label for="HotWaterSupplyFacility">給湯設備：</label>
                        <a class="hatena" :href="spec4_4help_url" target="_blank">？</a>
                        <select id="HotWaterSupplyFacility" class="custom-select custom-select-sm" v-model="hot_water_supply_facility"><option v-for="option in options.hot_water_supply_facility" :value="option.value">{{ option.label }}</option></select>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="spec-btn-group">
          <a href="#" class="btn btn-secondary btn-sm" @click.prevent="cancel">キャンセル</a>
          <a href="#" class="btn btn-primary btn-sm ml-3" @click.prevent="submit">OK</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      ...window.flashVars,
      closed: true,
      original: {
        spec_format: 0,
        pillar_material: 0,
        roof_structure: 0,
        insulation_material: 0,
        exterior_wall_material: 0,
        exterior_roof_material: 0,
        interior_roof_finish: 0,
        interior_wall_finish: 0,
        interior_floor_finish: 0,
        anti_pollen_facility: 0,
        natural_energy_facility: 0,
        floor_heating_facility: 0,
        hot_water_supply_facility: 0,
      },
    }
  },
  computed: {
    ...mapState('madori', [
      'spec_formats',
      'options',
    ]),
    spec_selected: {
      get() { return this.$store.state.madori.spec_selected },
      set(value) { this.$store.commit('madori/updateSpecSelected', value) },
    },
    spec_format: {
      get() { return this.$store.state.madori.spec_format },
      set(value) { this.$store.commit('madori/updateSpecFormat', value) },
    },
    pillar_material: {
      get() { return this.$store.state.madori.pillar_material },
      set(value) { this.$store.commit('madori/updatePillarMaterial', value) },
    },
    roof_structure: {
      get() { return this.$store.state.madori.roof_structure },
      set(value) { this.$store.commit('madori/updateRoofStructure', value) },
    },
    insulation_material: {
      get() { return this.$store.state.madori.insulation_material },
      set(value) { this.$store.commit('madori/updateInsulationMaterial', value) },
    },
    exterior_wall_material: {
      get() { return this.$store.state.madori.exterior_wall_material },
      set(value) { this.$store.commit('madori/updateExteriorWallMaterial', value) },
    },
    exterior_roof_material: {
      get() { return this.$store.state.madori.exterior_roof_material },
      set(value) { this.$store.commit('madori/updateExteriorRoofMaterial', value) },
    },
    interior_roof_finish: {
      get() { return this.$store.state.madori.interior_roof_finish },
      set(value) { this.$store.commit('madori/updateInteriorRoofFinish', value) },
    },
    interior_wall_finish: {
      get() { return this.$store.state.madori.interior_wall_finish },
      set(value) { this.$store.commit('madori/updateInteriorWallFinish', value) },
    },
    interior_floor_finish: {
      get() { return this.$store.state.madori.interior_floor_finish },
      set(value) { this.$store.commit('madori/updateInteriorFloorFinish', value) },
    },
    anti_pollen_facility: {
      get() { return this.$store.state.madori.anti_pollen_facility },
      set(value) { this.$store.commit('madori/updateAntiPollenFacility', value) },
    },
    natural_energy_facility: {
      get() { return this.$store.state.madori.natural_energy_facility },
      set(value) { this.$store.commit('madori/updateNaturalEnergyFacility', value) },
    },
    floor_heating_facility: {
      get() { return this.$store.state.madori.floor_heating_facility },
      set(value) { this.$store.commit('madori/updateFloorHeatingFacility', value) },
    },
    hot_water_supply_facility: {
      get() { return this.$store.state.madori.hot_water_supply_facility },
      set(value) { this.$store.commit('madori/updateHotWaterSupplyFacility', value) },
    },
  },
  watch: {
    closed(value) {
      if (value == false) {
        this.copyOriginal()
      }
    },
  },
  methods: {
    // ...mapActions('madori', [
    // ]),
    toggle() {
      this.closed = !this.closed
    },
    open() {
      this.closed = false
    },
    close() {
      this.closed = true
    },
    copyOriginal() {
      this.original.spec_selected              = this.spec_selected
      this.original.spec_format                = this.spec_format
      this.original.pillar_material            = this.pillar_material
      this.original.roof_structure             = this.roof_structure
      this.original.insulation_material        = this.insulation_material
      this.original.exterior_wall_material     = this.exterior_wall_material
      this.original.exterior_roof_material     = this.exterior_roof_material
      this.original.interior_roof_finish       = this.interior_roof_finish
      this.original.interior_wall_finish       = this.interior_wall_finish
      this.original.interior_floor_finish      = this.interior_floor_finish
      this.original.anti_pollen_facility       = this.anti_pollen_facility
      this.original.natural_energy_facility    = this.natural_energy_facility
      this.original.floor_heating_facility     = this.floor_heating_facility
      this.original.hot_water_supply_facility  = this.hot_water_supply_facility
    },
    cancel() {
      this.pillar_material            = this.original.pillar_material
      this.roof_structure             = this.original.roof_structure
      this.insulation_material        = this.original.insulation_material
      this.exterior_wall_material     = this.original.exterior_wall_material
      this.exterior_roof_material     = this.original.exterior_roof_material
      this.interior_roof_finish       = this.original.interior_roof_finish
      this.interior_wall_finish       = this.original.interior_wall_finish
      this.interior_floor_finish      = this.original.interior_floor_finish
      this.anti_pollen_facility       = this.original.anti_pollen_facility
      this.natural_energy_facility    = this.original.natural_energy_facility
      this.floor_heating_facility     = this.original.floor_heating_facility
      this.hot_water_supply_facility  = this.original.hot_water_supply_facility
      this.spec_format                = this.original.spec_format
      this.spec_selected              = this.original.spec_selected
      this.close()
    },
    submit() {
      this.spec_selected = true
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/bootstrap";

.spec {
  position: absolute;
  right: 0;
  top: 46px;
  z-index: 20;
  bottom: 25px;
  width: 840px;
  transition: 500ms ease width;
  &.closed {
    z-index: 10;
    width: 0;
  }
}
.spec-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1;
  top: 18px;
  left: -31px;
  width: 31px;
  height: 147px;
  background-color: #7CB743;
  border-radius: 8px 0 0 8px;
  text-decoration: none;
  box-shadow: 1.5px 1.5px 8px rgba(0, 0, 0, .2);
  writing-mode: vertical-rl;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  transition: .5s ease background-color;
  &:hover {
    background-color: #99CC00;
  }
  svg {
    transform: scale(-1,1);
  }
  .closed & svg {
    transform: scale(1,1);
  }
}
.spec-wrap {
  position: relative;
  z-index: 2;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.spec-window {
  padding: 18px 38px 0 38px;
  width: 840px;
  height: 100%;
  background-color: #fff;
  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: #7CB743;
  border-radius: 10px 0 0 10px;
  box-shadow: 1.5px 1.5px 8px rgba(0, 0, 0, .2);
  overflow: auto;
}
.spec-heading {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 18px;
  height: 29px;
  border-radius: 15px;
  background-color: #7CB743;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  small {
    margin-left: 20px;
    font-size: 13px;
    font-weight: normal;
    line-height: 1;
  }
}
.spec-formats {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3px;
}
.spec-formats-item {
  &:nth-child(4n-3) { flex: 0 0 30%; }
  &:nth-child(4n-2) { flex: 0 0 23%; }
  &:nth-child(4n-1) { flex: 0 0 22%; }
  &:nth-child(4n)   { flex: 0 0 25%; }
  margin-bottom: 5px;
}
.custom-control-label {
  color: #7CB743;
  font-weight: bold;
}
.custom-select-sm {
  padding: 3px 5px;
  height: 22px;
  font-size: 10px;
}
.spec-table {
  margin: 10px 0 0 20px;
}
.spec-btn-group {
  display: flex;
  justify-content: flex-end;
  .btn {
    width: 100px;
    font-weight: bold;
  }
}
.table {
  margin-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
  th {
    position: relative;
    padding: 1px 0;
    width: 95px;
    vertical-align: middle;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #666;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 95px;
      height: 60px;
      background-color: #eee;
    }
  }
  td {
    padding: 0 16px;
    font-size: 12px;
    font-weight: bold;
    color: #666;
    .col-4 {
      margin-top: 7px;
    }
  }
  label {
    margin-bottom: 5px;
  }
  tr:nth-child(4) th span {
    height: 113px;
  }
}
.hatena {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  background-color: #74A246;
  border-radius: 7.5px;
  color: #fff;
  font-size: 11px;
  line-height: 1;
  @include transition($btn-transition);
  @include button-variant($primary, $primary, #99CC00, #99CC00, #99CC00, #99CC00);
}
</style>


// WEBPACK FOOTER //
// assets/js/components/Spec.vue